// extracted by mini-css-extract-plugin
export var action = "RegisterForm-module--action--1Imi7";
export var colspan = "RegisterForm-module--colspan--xfb4f";
export var fields = "RegisterForm-module--fields--gM-y5";
export var form = "RegisterForm-module--form--YOt2c";
export var message = "RegisterForm-module--message--unGZX";
export var root = "RegisterForm-module--root--qqW2F";
export var txtmsg = "RegisterForm-module--txtmsg--dNfxE";